import { graphql } from '@e-socna/data-layer';
import type { EMPTY_STRING } from '@e-socna/empty';
import type { QuotationWorkflowId } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useMissionReadyContext } from '../../../contexts/MissionContext/hooks/useMissionReadyContext.hook';

const MissionQuotationInfoForm_CodeSuggestion_QueryDocument = graphql(`
  query MissionQuotationInfoForm_CodeSuggestion_Query(
    $missionId: Id!
    $workflowId: Id!
  ) {
    suggestQuotationInfoCode(missionId: $missionId, workflowId: $workflowId)
  }
`);

export const useCodeSuggestionQuery = (
  workflowId: QuotationWorkflowId | typeof EMPTY_STRING,
  enabled: boolean,
) => {
  const { missionId } = useMissionReadyContext();

  return useGraphQLQuery(
    MissionQuotationInfoForm_CodeSuggestion_QueryDocument,
    { missionId, workflowId: workflowId as QuotationWorkflowId },
    { enabled: enabled && !!workflowId },
  );
};
